import { GET_METHOD } from "./ApiMethods";

export const getCandidateDetails = async (id) => {
    try {
        let response = await GET_METHOD("profile", { candidate_id: id });
        return response;
    } catch (error) {
        return error;
    }
};
